import ProjectWrapper from "./ProjectWrapper";
import mangataGallo from '../images/projects/mangata-gallo.jpg';
import littleLemon from '../images/projects/little-lemon.jpg';
import phpRegister from '../images/projects/php-register.jpg';
import amayaJax from '../images/projects/amaya-jax.jpg';
import pierreM from '../images/projects/pierrem-old.jpg';
import belist from '../images/projects/belist.jpg';

function Projects() {
    const projectsList = [{
            title: 'Mangata Gallo',
            type: 'HTML, CSS',
            description: 'A landing page made for a fictionnal jewelry with custom mockups. A modern luxurious feel inspired by brands such as Seiko.',
            link: 'https://pierreminet.github.io/mangata-gallo/',
            source: mangataGallo,
        },{
            title: 'Little Lemon - (Code Only)',
            type: 'React JS, CSS',
            description: 'A mockup home page and table booking section for a fictionnal mediterranean restaurant based in Chicago.',
            link: 'https://github.com/PierreMinet/little-lemon-book',
            source: littleLemon,
        },{
            title: 'Amaya Jax',
            type: 'Wordpress, HTML, CSS, Elementor',
            description: 'A CMS website made for an independent author, the global appearance is based on her aesthetic and writing universe which combines horror, fantasy and romance.',
            link: 'https://amaya-jax.com/',
            source: amayaJax,
        },{
            title: 'Pierre M Designs - Previous Version (Code Only)',
            type: 'React JS, CSS, PHP, JSON',
            description: 'The previous version of this website : a more brutalist design, dynamic animations using React Motion, form control with Formik, dynamic image gallery using PHP and JSON.',
            link: 'https://github.com/PierreMinet/portfolio/tree/main',
            source: pierreM,
        },{
            title: 'PHP Register / Login - (Code Only)',
            type: 'HTML / PHP',
            description: 'A small PHP register and login system, it is still a work in progress, use at your own risks.',
            link: 'https://github.com/PierreMinet/php-register-login',
            source: phpRegister,
        },{
            title: 'BeList - (WIP)',
            type: 'React JS, PHP, JSON',
            description: 'An online grocery list application, still in early development.',
            link: 'https://github.com/PierreMinet/grocery-app-react',
            source: belist,
        },
        ];
        const displayProjects = projectsList.map(proj => {
            return <ProjectWrapper title={proj.title} type={proj.type} desc={proj.description} link={proj.link} source={proj.source} />
        })
    return (
        <article>
            <div className="large-card">
                <h3>Web Projects</h3>
                <p>Working mainly in front-end development using React.JS to build modern and seamless Single Page Applications.</p>
                <p>Also creating traditionnal websites using HTML, CSS and JavaScript ES6, or even Wordpress.</p>
                <div className="separator"></div>
                <div className="gallery">
                    {displayProjects}
                </div>
            </div>
        </article>
    )
}

export default Projects;